import React, { useState } from "react";
import PaymentSummary from "./paymentSummary";
import PaymentForm from "../payment/PaymentForm";
import { CSSTransition } from "react-transition-group";
import popupService from "../popup-service";
import PaymentSucceeded from "../payment/PaymentSucceeded";
import PropTypes from "prop-types";
import BrowserCardPaymentForm from "../payment/BrowserCardPaymentForm";
import usePaymentRequest from "../customHooks/usePaymentRequest";


const PaymentPage = ({ paymentData }) => {
	const [paymentSucceeded, setPaymentSucceeded] = useState(false);
	const [showPaymentSucceeded, setShowPaymentSucceeded] = useState(false);

	const onPaymentSucceeded = () => {
		setPaymentSucceeded(true);
		setTimeout(() => setShowPaymentSucceeded(true), 1000);
	};

	const onPaymentFailed = (errorMessage) => {
		popupService.renderErrorMessage(errorMessage);
	};

	const formatter = Intl.NumberFormat("en-GB", {
		style: "currency",
		currency: "GBP",
	});

	const {		
		paymentRequest
	} = usePaymentRequest(paymentData.clientSecret, false, paymentData.totalPrice, paymentData.description, onPaymentSucceeded, onPaymentFailed);


	return (
		<>
			<PaymentSummary
				totalPrice={paymentData.totalPrice}
				quantityOfTickets={paymentData.quantityOfTickets}
				ticketPrice={paymentData.ticketPrice}
			/>
			<CSSTransition
				in={showPaymentSucceeded}
				timeout={400}
				mountOnEnter
				classNames="fade"
			>
				<PaymentSucceeded
					auctionId={paymentData.auctionId}
					isAdmin={paymentData.isAdmin ?? false}
					todaysDate={paymentData.dateNow}
					totalToPay={formatter.format(paymentData.totalPrice)}
				/>
			</CSSTransition>
			{paymentRequest ? <BrowserCardPaymentForm
				paymentSucceeded={paymentSucceeded}
				paymentRequest={paymentRequest}
			/>
				: null}
			<PaymentForm
				clientSecret={paymentData.clientSecret}
				showError={onPaymentFailed}
				onSuccess={onPaymentSucceeded}
				customerName={paymentData.email}
				deliveryChosen={false}
				paymentSucceeded={paymentSucceeded}
			/>
		</>
	);
};

PaymentPage.propTypes = {
	paymentData: PropTypes.object.isRequired,
};

export default PaymentPage;
